import React from 'react';
import { useSearchParams } from 'react-router-dom';
import LiveKitMeetingScheduler from './LiveKitMeetingScheduler';
import LiveKitCalendarView from './LiveKitCalendarView';

const LiveKitMeetings = ({ user, activeAgency }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeSection = searchParams.get('subsection') || 'schedule-meeting';
  const setActiveSection = (section) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.set('subsection', section);
      return next;
    });
  };

  return (
    <div className="super-admin-internal-layout velvet-meetings-panel">
      <nav className="internal-nav">
        <div className="internal-nav-items">
          <button
            className={`internal-nav-btn ${activeSection === 'schedule-meeting' ? 'active' : ''}`}
            onClick={() => setActiveSection('schedule-meeting')}
          >
            Schedule Meeting
          </button>
          <button
            className={`internal-nav-btn ${activeSection === 'calendar-view' ? 'active' : ''}`}
            onClick={() => setActiveSection('calendar-view')}
          >
            Calendar View
          </button>
        </div>
      </nav>
      <div className="internal-content">
        {activeSection === 'calendar-view' ? (
          <LiveKitCalendarView user={user} activeAgency={activeAgency} />
        ) : (
          <LiveKitMeetingScheduler user={user} activeAgency={activeAgency} />
        )}
      </div>
    </div>
  );
};

export default LiveKitMeetings;
